import { useQuery } from "@tanstack/react-query";
import { TeamSyncBackends } from "@graylog/enterprise-api";
const fetch = (backendId) => TeamSyncBackends.get(backendId);
const useSAMLTeamSyncConfig = (backendId) => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ["saml.team.sync.backend"],
    queryFn: () => fetch(backendId),
    retry: false
  });
  if (isError) {
    return { isLoading: false, teamSyncBackend: void 0 };
  }
  return { isLoading, teamSyncBackend: data == null ? void 0 : data.backend };
};
export default useSAMLTeamSyncConfig;
